import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const QuickNav = ({ sections, activeTab, onTabChange }) => {
  return (
    <div className="bg-surface rounded-lg border border-border p-4 sticky top-24">
      <h3 className="text-lg font-semibold text-text-primary mb-4">Section Guide</h3>
      <nav className="space-y-2 mb-6">
        {sections?.map((section) => (
          <button
            key={section?.id}
            onClick={() => onTabChange(section?.id)}
            className={`w-full flex items-center space-x-3 p-3 rounded-lg text-left transition-colors ${
              activeTab === section?.id
                ? 'bg-accent text-accent-foreground'
                : 'hover:bg-muted text-text-primary'
            }`}
          >
            <Icon 
              name={section?.icon} 
              size={18} 
              className={activeTab === section?.id ? 'text-accent-foreground' : 'text-text-secondary'}
            />
            
            <div className="flex-1 min-w-0">
              <div className="font-medium">{section?.name}</div>
              <p className="text-xs opacity-80 truncate">{section?.description}</p>
            </div>
          </button>
        ))}
      </nav>
      {/* Quick Links */}
      <div className="border-t border-border pt-4">
        <h4 className="text-sm font-medium text-text-primary mb-3">Quick Links</h4>
        
        <div className="space-y-2">
          <Button
            variant="ghost"
            size="sm"
            fullWidth
            iconName="Edit3"
            iconPosition="left"
            iconSize={16}
            className="justify-start"
            onClick={() => window.open('/artist-content-management', '_blank')}
          >
            Content Manager
          </Button>
          
          <Button
            variant="ghost"
            size="sm"
            fullWidth
            iconName="Smartphone"
            iconPosition="left"
            iconSize={16}
            className="justify-start"
            onClick={() => window.open('/mobile-app-preview', '_blank')}
          >
            App Preview
          </Button>
          
          <Button
            variant="ghost"
            size="sm"
            fullWidth
            iconName="MessageCircle"
            iconPosition="left"
            iconSize={16}
            className="justify-start"
            onClick={() => window.open('mailto:support@idartists.com', '_blank')}
          >
            Contact Support
          </Button>
        </div>
      </div>
      {/* Help Stats */}
      <div className="mt-6 pt-4 border-t border-border">
        <div className="text-center">
          <div className="w-12 h-12 bg-primary rounded-full flex items-center justify-center mx-auto mb-3">
            <Icon name="HelpCircle" size={20} color="white" />
          </div>
          <p className="text-sm text-text-secondary">
            Need more help?
          </p>
          <p className="text-xs text-text-secondary mt-1">
            Contact our support team
          </p>
        </div>
      </div>
    </div>
  );
};

export default QuickNav;